import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import cart from './modules/cart'
import library from './modules/library'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    cart,
    library
  }
})
